import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import BrandSplash from "./BrandSplash";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null) {
    return <BrandSplash caption="Calculating yield…" />;
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc }} />;
  return children;
}
